import { lazyLoadView } from '@utils/LazyLoad'
import { FEATURES, SEARCH_GROUPS } from '@constants/Text'

export default [
  {
    path: '/dashboard',
    name: 'dashboard-bi',
    // redirect: '/dashboard/p',
    meta: {
      can_show: FEATURES.BI_V2,
      search: {
        title: 'BI',
        description: 'Business Intelligence: dashboards e indicadores',
        keywords: [
          'bi',
          'business intelligence',
          'dashboards',
          'indicadores',
          'métricas',
        ],
        icon: 'mdi-view-dashboard',
        group: SEARCH_GROUPS.ANALISES,
      },
    },
    component: () =>
      lazyLoadView(import('@modules/dashboard/views/dashboard-nav-bar.vue')),
    children: [
      {
        path: 'p/:page',
        name: 'dashboard-bi.page',
        component: () =>
          lazyLoadView(import('@modules/dashboard/views/view-dynamic.vue')),
      },
      {
        path: 'mix',
        name: 'dashboard-bi.mix',
        meta: {
          can_show: 'biMix',
          search: {
            title: 'Mix de Produtos',
            description: 'Distribuição e mix de produtos da carteira',
            keywords: [
              'mix',
              'produtos',
              'distribuição',
              'alocação',
              'carteira',
            ],
            group: SEARCH_GROUPS.ANALISES,
          },
        },
        component: () =>
          lazyLoadView(
            import('@modules/dashboard/views/mixProdutos/mix-produtos-view')
          ),
        children: [
          {
            path: 'profissionais',
            name: 'dashboard-bi.mix.professionals',
            meta: {
              can_show: 'biMix',
            },
            component: () =>
              lazyLoadView(
                import('@modules/dashboard/views/mixProdutos/mix-produtos-view')
              ),
          },
        ],
      },
    ],
  },
]
